"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContainerComponent = void 0;
const React = __importStar(require("react"));
const LanguageTexts = __importStar(require("@genesys/shared/lib/language-texts"));
const property_1 = require("@genesys/property");
const R = __importStar(require("ramda"));
const ProductProperties = __importStar(require("@genesys/shared/lib/product-properties"));
const QuantityConverison = __importStar(require("@genesys/shared/lib/quantity-conversion"));
const Contexts = __importStar(require("../contexts"));
const AmountFormatSelector = __importStar(require("../amount-format-selector"));
const ScreenAmountProfile = __importStar(require("../screen-amount-profile"));
const DefaultRenderers = __importStar(require("./default-renderers"));
class ContainerComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            activeQuantitySelectors: {}
        };
        this.toggleQuantitySelector = this.toggleQuantitySelector.bind(this);
    }
    toggleQuantitySelector(propertyName) {
        if (this.state.activeQuantitySelectors[propertyName]) {
            this.setState((prev) => (Object.assign(Object.assign({}, prev), { activeQuantitySelectors: R.dissoc(propertyName, this.state) })));
            return;
        }
        this.setState((prev) => (Object.assign(Object.assign({}, prev), { activeQuantitySelectors: Object.assign(Object.assign({}, this.state.activeQuantitySelectors), { [propertyName]: true }) })));
    }
    render() {
        return (React.createElement(Contexts.TranslateContext.Consumer, null, translate => (React.createElement(ScreenAmountProfile.ScreenAmountProfile, null, ({ deleteAmountFieldFormat, getPropertyFormats, measureSystem, quantityDefaults, saveAmountFieldFormat }) => {
            const { fieldGroup, formatSelectorRenderer = AmountFormatSelector.FormatSelectorRenderer, properties, propertyDefinitions, resultGroupRenderer = DefaultRenderers.defaultResultGroupRenderer, resultPropertyRenderer = DefaultRenderers.defaultResultPropertyRenderer, showLabels = true, customTranslation } = this.props;
            const defaultTranslation = {
                groupKey: (groupKey, translateArg) => translateArg(LanguageTexts.globalPropertyName(groupKey)),
                propertyName: (propertyName, translateArg) => translateArg(LanguageTexts.globalPropertyName(propertyName)),
                propertyValue: (propertyName, propertyValue, translateArg) => {
                    const propertyDefinition = propertyDefinitions.find(found => found.propertyName === propertyName);
                    if (!propertyDefinition) {
                        throw new Error("Property name " +
                            propertyName +
                            " not found in propertyDefinitions.");
                    }
                    return translateArg(propertyDefinition.selectorType === "Checkbox"
                        ? propertyValue
                            ? LanguageTexts.yes()
                            : LanguageTexts.no()
                        : LanguageTexts.globalPropertyName(propertyName + "_" + propertyValue));
                }
            };
            const translation = customTranslation
                ? Object.assign(Object.assign({}, defaultTranslation), customTranslation) : defaultTranslation;
            const sortedDefinitions = R.sortBy(pd => pd.sortNo, propertyDefinitions);
            const propertyFormats = getPropertyFormats(fieldGroup, properties);
            const onPropertyFormatChanged = (propertyName, unit, decimalCount) => {
                saveAmountFieldFormat(fieldGroup, propertyName, unit, decimalCount);
            };
            const groups = R.compose(R.reduce((acc, [key, definitions]) => {
                const resultProperties = definitions.map(d => createResultProperty(translation, translate, this.toggleQuantitySelector, saveAmountFieldFormat, deleteAmountFieldFormat, this.state.activeQuantitySelectors, propertyFormats, fieldGroup, d, properties, QuantityConverison.createOnQuantityChange(onPropertyFormatChanged, measureSystem, quantityDefaults, d.propertyName)));
                const group = {
                    key: key,
                    translatedName: translation.groupKey(key, translate),
                    properties: resultProperties
                };
                return acc.concat(group);
            }, []), R.toPairs, R.groupBy((d) => d.group || "no-group"))(sortedDefinitions);
            return (React.createElement("div", null, groups.map(group => {
                return resultGroupRenderer(resultPropertyRenderer, formatSelectorRenderer, showLabels, group);
            })));
        }))));
    }
}
exports.ContainerComponent = ContainerComponent;
function createResultProperty(translation, translate, toggleQuantitySelector, saveAmountFieldFormat, deleteAmountFieldFormat, activeQuantitySelectors, propertyFormats, fieldGroup, propertyDefinition, properties, onQuantityChange) {
    const propertyValue = property_1.PropertyValueSet.get(propertyDefinition.propertyName, properties);
    const { selectedUnit, selectedDecimalCount } = propertyValue && propertyValue.type === "amount"
        ? ProductProperties.getFormat(propertyFormats[propertyDefinition.propertyName], propertyValue.value)
        : {
            selectedDecimalCount: undefined,
            selectedUnit: undefined
        };
    const isQuantitySelectorActive = activeQuantitySelectors[propertyDefinition.propertyName];
    const formattedValue = propertyValue &&
        (propertyValue.type === "integer"
            ? translation.propertyValue(propertyDefinition.propertyName, property_1.PropertyValue.getInteger(propertyValue), translate)
            : ProductProperties.getValue(propertyValue, propertyFormats[propertyDefinition.propertyName], propertyDefinition.conversionParameters));
    const resultProperty = Object.assign(Object.assign({}, propertyDefinition), { deleteAmountFieldFormat: () => {
            deleteAmountFieldFormat(fieldGroup, propertyDefinition.propertyName);
        }, toggleQuantitySelector: () => {
            toggleQuantitySelector(propertyDefinition.propertyName);
        }, formattedValue, saveAmountFieldFormat: (unit, decimalCount) => {
            saveAmountFieldFormat(fieldGroup, propertyDefinition.propertyName, unit, decimalCount);
        }, onQuantityChange: onQuantityChange, selectedUnit,
        selectedDecimalCount, userSelected: (propertyFormats[propertyDefinition.propertyName] &&
            propertyFormats[propertyDefinition.propertyName].userDefined) ||
            false, isQuantitySelectorActive, translatedName: translation.propertyName(propertyDefinition.propertyName, translate), type: propertyValue && propertyValue.type });
    return resultProperty;
}
//# sourceMappingURL=container-component.js.map